import { AdminCatalogItemViewModel } from '@common/model/catalog/item/admin.view';
import { Platform } from '@common/model/platform';

export const isCreatedByBot = (model: AdminCatalogItemViewModel): boolean => {
  return model.clientProfile.registrationPlatform === Platform.ApiServer;
};
